var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.25C14.6367 2.25 17.7933 8.4 17.9436 8.7C18.0188 8.85 18.0188 9.15 17.9436 9.3C17.7933 9.6 14.6367 15.75 9 15.75C3.6944 15.75 0.586118 10.3014 0.113878 9.47355L0.113873 9.47354L0.113863 9.47353C0.084397 9.42187 0.0651964 9.38822 0.0563674 9.375C-0.0187891 9.15 -0.0187891 8.925 0.0563674 8.7C0.206681 8.4 3.36326 2.25 9 2.25ZM1.5595 9C2.31106 10.2 4.94154 14.25 9 14.25C13.0585 14.25 15.6889 10.2 16.4405 9C15.6889 7.8 13.0585 3.75 9 3.75C4.94154 3.75 2.23591 7.8 1.5595 9ZM9 6C7.34656 6 5.99374 7.35 5.99374 9C5.99374 10.65 7.34656 12 9 12C10.6534 12 12.0063 10.65 12.0063 9C12.0063 7.35 10.6534 6 9 6ZM7.49687 9C7.49687 9.825 8.17328 10.5 9 10.5C9.82672 10.5 10.5031 9.825 10.5031 9C10.5031 8.175 9.82672 7.5 9 7.5C8.17328 7.5 7.49687 8.175 7.49687 9Z",
    fill: "#212529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4857_3614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 18,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.25C14.6367 2.25 17.7933 8.4 17.9436 8.7C18.0188 8.85 18.0188 9.15 17.9436 9.3C17.7933 9.6 14.6367 15.75 9 15.75C3.6944 15.75 0.586118 10.3014 0.113878 9.47355L0.113873 9.47354L0.113863 9.47353C0.084397 9.42187 0.0651964 9.38822 0.0563674 9.375C-0.0187891 9.15 -0.0187891 8.925 0.0563674 8.7C0.206681 8.4 3.36326 2.25 9 2.25ZM1.5595 9C2.31106 10.2 4.94154 14.25 9 14.25C13.0585 14.25 15.6889 10.2 16.4405 9C15.6889 7.8 13.0585 3.75 9 3.75C4.94154 3.75 2.23591 7.8 1.5595 9ZM9 6C7.34656 6 5.99374 7.35 5.99374 9C5.99374 10.65 7.34656 12 9 12C10.6534 12 12.0063 10.65 12.0063 9C12.0063 7.35 10.6534 6 9 6ZM7.49687 9C7.49687 9.825 8.17328 10.5 9 10.5C9.82672 10.5 10.5031 9.825 10.5031 9C10.5031 8.175 9.82672 7.5 9 7.5C8.17328 7.5 7.49687 8.175 7.49687 9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4857_3614)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#3876BB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.3a0b865f8ba2b42f6d4de9e2795889ac.svg";
export { ForwardRef as ReactComponent };